import { createCompatVariables } from "./compat";
import { createTypusTokens } from "./tokens";
import type { ThemeDefinition } from "./types";

export { definitionFromSelectedTheme } from "./fromStore";
export { createTypusTokens } from "./tokens";
export type { TypusTokens } from "./tokens";
export type { ThemeDefinition } from "./types";

/**
 * Build every CSS variable needed to render a theme:
 * the `--typ-*` tokens plus the legacy names pointing at them
 * @param definition Theme definition
 * @returns CSS variables
 */
export function buildThemeVariables(definition: ThemeDefinition) {
  const tokens = createTypusTokens(definition);

  return {
    tokens,
    variables: {
      ...tokens,
      ...createCompatVariables(),
    } as Record<string, string>,
  };
}
